<template>
  <appLayout04>
    <appHeader
      slot="appHeader"
      :showUserMenu.sync="showUserMenu"
    >
    </appHeader>
    <div
      slot="appContents"
      class="app-contents"
    >
      <snackbarDialog></snackbarDialog>
      <div class="">
        <appLoginForm v-show="!$auth.logged">
        </appLoginForm>
        <div v-if="$auth.logged">
          <router-view>
          </router-view>
        </div>
      </div>
      <!-- dialogs -->
      <loginDialog :dialog="$auth.dialog.login"></loginDialog>
      <loginResetDialog :dialog="$auth.dialog.loginReset"></loginResetDialog>
      <loginChangeDialog :dialog="$auth.dialog.loginChange"></loginChangeDialog>
      <faleConoscoDialog :plugin="$faleConosco"></faleConoscoDialog>
      <deleteDialog></deleteDialog>
    </div>
    <appFooter slot="appFooter">
    </appFooter>
  </appLayout04>
</template>

<script>
import appHeader from '@/app/appHeader'
import appFooter from '@/app/appFooter'
import appLayout04 from '@/app/appLayout'
import appLoginForm from '@/app/appLoginForm'
import loginDialog from 'acefy/dialogs/loginDialog'
import loginResetDialog from 'acefy/dialogs/loginResetDialog'
import loginChangeDialog from 'acefy/dialogs/loginChangeDialog'
import deleteDialog from 'acefy/dialogs/deleteDialog'
import snackbarDialog from 'acefy/dialogs/snackbarDialog'
import faleConoscoDialog from 'acefy/dialogs/faleConoscoDialog'

export default {
  data: function () {
    return {
      showUserMenu: false
    }
  },
  components: {
    appHeader,
    appFooter,
    appLayout04,
    appLoginForm,
    loginDialog,
    loginResetDialog,
    loginChangeDialog,
    deleteDialog,
    snackbarDialog,
    faleConoscoDialog
  }
}
</script>

<style>
.app {
  margin: 20px;
}
</style>
